module.exports = __webpack_public_path__ + "img/linda-harris-reynolds.7d8850ea.jpg";